import * as Sentry from '@sentry/browser';
import { History } from 'history';
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import trackEvent from '../../utils/analytics';

// This is used to send page change events to Mixpanel
const TrackPageViews = ({ history }: { history: History }) => {
  useEffect(
    () => {
      try {
        // Track first page load that doesn't trigger history.listen()
        trackEvent.pageview({ path: history.location.pathname });
      } catch (e) {
        Sentry.captureException(e, { tags: { noFeedback: true } });
      }
      history.listen(() => {
        try {
          trackEvent.pageview({ path: history.location.pathname });
        } catch (e) {
          Sentry.captureException(e, { tags: { noFeedback: true } });
        }
      });
    },
    [] // eslint-disable-line
  );
  return null;
};

export default withRouter(TrackPageViews);
